<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-cubes me-2"></i>Aufgabentypen ({{totalEntries}})</h1>
</div>

<button type="button" class="btn btn-primary mb-3" [routerLink]="['/tasktype', 0]">Aufgabentyp anlegen</button>

<div class="table-responsive">
    <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th (click)="setOrder('name')">
                Name <i class="fas" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('tasks')">
                # Aufgaben <i class="fas" *ngIf="predicate == 'tasks'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/tasktype', entry.id]">
            <td>{{ entry.name }}</td>
            <td>{{ entry.tasks }}</td>
        </tr>
        </tbody>
    </table>
</div>
